import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import AtelierCanvas from "@/components/website-templates/AtelierCanvas";
import type { SiteSpec } from "@/components/website-templates/AtelierCanvas";

const API_URL = process.env.REACT_APP_BACKEND_URL || "";

/** Site publié d'un client, visible sans compte. */
export default function SitePublic({ slug: slugProp }: { slug?: string }) {
  const params = useParams();
  const slug = slugProp || params.slug || "";
  const [site, setSite] = useState<SiteSpec | null>(null);
  const [absent, setAbsent] = useState(false);
  useEffect(() => {
    fetch(`${API_URL}/api/atelier/public/${encodeURIComponent(slug)}`).then(async (r) => {
      if (!r.ok) { setAbsent(true); return; }
      const j = await r.json(); setSite(j.site); document.title = j.site.name;
    }).catch(() => setAbsent(true));
  }, [slug]);
  if (absent) return <div className="min-h-screen flex items-center justify-center bg-background text-muted-foreground text-sm">Ce site n'existe pas ou n'est plus publié.</div>;
  if (!site) return <div className="min-h-screen bg-background" />;
  return <AtelierCanvas spec={site} />;
}
